import { render, staticRenderFns } from "./popUp.vue?vue&type=template&id=edeb4996"
import script from "./popUp.vue?vue&type=script&lang=js"
export * from "./popUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports